import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import qs from "qs";
import router from "./router";
import store from "./store";

import "vant/lib/icon/local.css";
// import Vconsole from "vconsole";
// 引入vant ui

import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";

import {
  Button,
  Toast,
  Dialog,
  Notify,
  Popup,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  NavBar
} from "vant";
Vue.use(Button);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Notify);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(NavBar);
Vue.use(Button);
Vue.use(Toast);

// 将所有 loading Toast 设置为背景不可点击
Toast.setDefaultOptions("loading", { forbidClick: true });
// let vConsole = new Vconsole();
// Vue.use(vConsole);

Vue.config.productionTip = false;
Vue.prototype.$axios = axios; // 全局注册，使用方法为:this.$axios
Vue.prototype.$qs = qs; // 全局注册，使用方法为:this.$qs
Vue.use(VXETable);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
